export const removeEmpty = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === "object") {
      newObj[key] = removeEmpty(obj[key]); // recurse
    } else if (obj[key] != null && obj[key] !== "") {
      newObj[key] = obj[key]; // copy value
    }
  });
  return newObj;
};

export const cleanOrder = (obj) => {
  const newObj = removeEmpty(obj);
  Object.keys(newObj).forEach((key) => {
    if (Object.keys(newObj[key]).length === 0) {
      delete newObj[key];
    }
  });
  return newObj;
};

export const clearEmpty = (
  obj,
  { preserveNullPaths = [] } = {},
  currentPath = "",
) => {
  // Если значение не является объектом или равно null, возвращаем его как есть
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  // Для массивов создаем новый массив с очищенными элементами
  if (Array.isArray(obj)) {
    const clearedArray = obj
      .map((item) => clearEmpty(item, { preserveNullPaths }, currentPath))
      .filter((item) => {
        if (item === null || item === undefined) return false;
        if (typeof item === "object" && Object.keys(item).length === 0)
          return false;
        return true;
      });
    return clearedArray.length > 0 ? clearedArray : undefined;
  }

  // Для объектов создаем новый объект с очищенными свойствами
  const clearedObj = {};
  for (const key in obj) {
    const nextPath = currentPath ? `${currentPath}.${key}` : key;
    const value = clearEmpty(obj[key], { preserveNullPaths }, nextPath);

    const isPreservedNull =
      value === null && preserveNullPaths.includes(nextPath);

    // Проверяем, должно ли быть значение сохранено
    const shouldBeSaved =
      isPreservedNull ||
      (value !== null &&
        value !== undefined &&
        !(typeof value === "object" && Object.keys(value).length === 0) &&
        (typeof value !== "string" || value.trim() !== ""));

    if (shouldBeSaved) {
      clearedObj[key] = value;
    }
  }
  return Object.keys(clearedObj).length > 0 ? clearedObj : undefined;
};
